export const GET_USAGER_SUCCESS = "GET_USAGER_SUCCESS";
export const GET_USAGER_FAIL = "GET_USAGER_FAIL";
export const GET_SELECTED_ACTION_SOCIALE = "GET_SELECTED_ACTION_SOCIALE";
export const GET_ALL_ACTION_SOCIALE = "GET_ALL_ACTION_SOCIALE";
export const GET_SELECTED_EXERCICE = "GET_SELECTED_EXERCICE";
export const GET_FICHE = "GET_FICHE";
export const GET_OPT_JUSTIFICATIF = "GET_OPT_JUSTIFICATIF";
export const GET_MAX_VAL_PRESTATION = "GET_MAX_VAL_PRESTATION";
export const GET_IBAN = "GET_IBAN";
export const GET_PAC = "GET_PAC";
export const GET_PARAMS_ENFANT = "GET_PARAMS_ENFANT";
export const GET_FULL_ACTION_SOCIALE = "GET_FULL_ACTION_SOCIALE";
export const GET_CESU_MULTI_TAUX = "GET_CESU_MULTI_TAUX";
